enum SharedEndpointIconSize {
  XSMALL = 'xsmall',
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

type SharedEndpointIconProps = {
  size: SharedEndpointIconSize;
};

export { SharedEndpointIconSize, SharedEndpointIconProps };
